module.exports = __webpack_public_path__ + "static/media/clone-tool-white.88d41e6e.svg";